<template>
  <v-container
    id="extended-forms"
    fluid
    tag="section"
  >
    <validation-observer
      v-slot="{ handleSubmit }"
    >
      <form @submit.prevent="handleSubmit(submitForm) ">
        <v-row>
          <v-col cols="12">
            <base-material-card
              class="pa-6"
              color="success"
              icon="mdi-card-plus"
              :title="title"
            >
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
                :loading="loadingSliderImage"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-row
                      class="mx-auto"
                      justify="space-around"
                      style="max-width: 1650px;"
                    >
                      <v-col
                        cols="auto"
                        class="text-center"
                      >
                        <input
                          ref="file"
                          type="file"
                          class="d-none"
                          @change="selectImage"
                        >
                        <div class="font-weight-bold grey--text">
                          Selecciona una imagen (Recomendado 1650x400)
                        </div>
                        <v-card
                          :class="imagePreview ? 'success--text' : 'grey--text'"
                          class="mx-auto mt-0 d-inline-flex v-card--account"
                          outlined
                          height="400"
                          width="1650"
                          @click="$refs.file.click()"
                        >
                          <v-img
                            v-if="imagePreview"
                            :src="imagePreview"
                            height="100%"
                            width="100%"
                          />
                          <v-icon
                            v-else
                            class="mx-auto"
                            size="96"
                          >
                            mdi-image-plus
                          </v-icon>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <div class="pa-3 text-center">
                  <v-btn
                    color="warning"
                    default
                    @click="goToList"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    color="success"
                    default
                    type="submit"
                    :disabled="!imagePreview"
                    :loading="loadingSave"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const sliderImagesRespository = repositoryFactory.get('sliderImages')

  export default {
    inject: ['theme'],
    name: 'SliderImageCrud',
    $_veeValidate: {
      validator: 'new',
    },
    data: () => ({
      sliderImage: {
        internalCode: 'home',
      },
      imagePreview: null,
      imageBytes: null,
      showErrorMessage: false,
      errorMessage: '',
      loadingSliderImage: false,
      formAction: null,
      loadingSave: false,
    }),
    computed: {
      title () {
        return this.formAction === 'add' ? this.$t('add-sliderImage') : this.$t('modify-sliderImage')
      },
    },
    mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingSliderImage = true
        var id = this.$route.params.id
        sliderImagesRespository.getById(id).then(response => {
          self.loadingSliderImage = false
          self.sliderImage = Object.assign({}, response.data.data)
          console.log(self.sliderImage)
          if (self.sliderImage.sections != null) {
            self.sliderImage.sectionsId = self.sliderImage.sections.map((x) => x.id)
          }
          if (self.sliderImage.sliderImageImage.length > 0) {
            self.imagePreview = self.sliderImage.sliderImageImage[0].url
          }
          if (self.sliderImage.gameLineId != null) {
            this.getExpansions(self.gameLineId)
          }
        }).catch(err => {
          self.loadingSliderImage = false
          alert(err)
        })
      }
    },
    methods: {
      submitForm (scope) {
        var self = this
        var data = new FormData()
        data.append('data', JSON.stringify(this.sliderImage))
        if (this.imageBytes != null) {
          data.append('imageBytes', this.imageBytes, this.imageBytes.name)
        } else {
          data.append('imageBytes', null)
        }
        self.loadingSave = true
        if (self.formAction !== 'add') {
          data.append('id', this.sliderImage.id)
          sliderImagesRespository.updateSliderImage(data, this.sliderImage.id).then(response => {
            if (response.data.isValid) {
              self.goToList()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = true
          })
        } else {
          console.log(data)
          sliderImagesRespository.addSliderImage(data).then(response => {
            if (response.data.isValid) {
              self.goToList()
              self.formAction = 'modify'
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = false
          })
        }
      },
      selectImage (val) {
        var self = this
        const value = val.target.files[0]
        if (!value) return (self.imagePreview = null)
        self.imagePreview = URL.createObjectURL(value)
        self.imageBytes = value
      },
      goToList () {
        this.$router.push({ name: 'sliderImages' })
      },
    },
  }
</script>
